module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 0.73445","quantity":0.00734},{"color":"#9dc4b5","label":" 0.73445- 4.00407","quantity":0.04004},{"color":"#e6efc3","label":" 4.00407- 5.28601","quantity":0.05286},{"color":"#ffe89e","label":" 5.28601- 6.92175","quantity":0.06922},{"color":"#f5af7f","label":" 6.92175- 9.03385","quantity":0.09034},{"color":"#ed6d32","label":" 9.03385- 21.58211","quantity":0.21582}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/cfxssl_raster/maize_MME_1981_2016_lcr_100.json
// module id = TwCX
// module chunks = 171